/**
* 投放管理 投放明细
*/
<template>
    <div class="detailed">
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>投放管理</el-breadcrumb-item>
            <el-breadcrumb-item>投放明细</el-breadcrumb-item>
        </el-breadcrumb>
        <!-- 搜索筛选 -->
        <el-form :inline="true" :model="formInline" class="user-search">
            <el-form-item label="应用">
                <el-autocomplete size="small" popper-class="my-autocomplete" v-model="formInline.app_name"
                    :fetch-suggestions="paramValueSearch1" @select="handleSelect($event,1)" @change="handleChange1" placeholder="应用">
                    <i class="el-icon-edit el-input__icon" slot="suffix"></i>
                    <template slot-scope="{ item }">
                        <div class="name">{{ item.value }}</div>
                    </template>
                </el-autocomplete>
            </el-form-item>
            <el-form-item label="渠道">
                <el-autocomplete size="small" popper-class="my-autocomplete" v-model="formInline.channel_name"
                    :fetch-suggestions="paramValueSearch2" @select="handleSelect($event,2)" @change="handleChange1" placeholder="渠道">
                    <i class="el-icon-edit el-input__icon" slot="suffix"></i>
                    <template slot-scope="{ item }">
                        <div class="name">{{ item.value }}</div>
                    </template>
                </el-autocomplete>
            </el-form-item>
            <el-form-item label="生效开始日期">
                <el-date-picker size="small" v-model="formInline.enable_begindate" value-format="yyyy-MM-dd" type="date"
                    placeholder="输入生效开始日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="生效截至日期">
                <el-date-picker size="small" v-model="formInline.enable_enddate" value-format="yyyy-MM-dd" type="date"
                    placeholder="输入生效截至日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-search" @click="search" v-auth="'putoninfo.list'">
                    搜索</el-button>
                <el-button size="small" type="default" icon="el-icon-refresh" @click="reset">重置</el-button>
                <el-button size="small" type="primary" icon="el-icon-circle-plus" @click="handleEdit()"
                    v-auth="'putoninfo.addorupdate'">添加</el-button>
            </el-form-item>
        </el-form>
        <!--列表-->
        <div class="el-table-con">
            <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
                element-loading-text="拼命加载中" style="width: 100%;" @sort-change="sortChange">
                <el-table-column align="center" type="selection" width="60">
                </el-table-column>
                <el-table-column align="center" sortable="custom" prop="puton_plan_id" label="计划ID" width="100">
                </el-table-column>
                <el-table-column align="center" sortable="custom" prop="puton_id" label="明细ID" width="100">
                </el-table-column>
                <el-table-column align="center" sortable="custom" prop="app_id" label="应用ID" width="100">
                </el-table-column>
                <el-table-column align="center" sortable="custom" prop="app_name" label="应用名称" width="120">
                </el-table-column>
                <el-table-column align="center" sortable="custom" prop="channel_id" label="渠道ID" width="100">
                </el-table-column>
                <el-table-column align="center" sortable="custom" prop="channel_name" label="渠道名称" width="120">
                </el-table-column>
                <el-table-column align="center" sortable="custom" prop="app_price" label="应用单价" width="120">
                </el-table-column>
                <el-table-column align="center" sortable="custom" prop="channel_price" label="渠道单价" width="120">
                </el-table-column>
                <el-table-column align="center" sortable="custom" prop="limit_num" label="量级" width="120">
                </el-table-column>
                <el-table-column align="center" sortable="custom" prop="channel_click_qty" label="渠道点击数" width="120">
                </el-table-column>
                <el-table-column align="center" sortable="custom" prop="channel_activate_qty" label="渠道激活数" width="120">
                </el-table-column>
                <el-table-column align="center" sortable="custom" prop="app_callback_qty" label="应用回调数" width="120">
                </el-table-column>
                <el-table-column align="center" sortable="custom" prop="app_settlement_qty" label="应用结算数" width="120">
                </el-table-column>
                <el-table-column align="center" sortable="custom" prop="channel_settlement_qty" label="渠道结算数"
                    width="120">
                </el-table-column>
                <el-table-column align="center" sortable="custom" prop="enable_date" label="生效日期" width="200">
                </el-table-column>
                <el-table-column align="center" sortable="custom" label="生效时间" width="200">
                    <template slot-scope="scope">{{scope.row.enable_begintime}} 至
                        {{scope.row.enable_endtime}}</template>
                </el-table-column>
                <el-table-column align="center" sortable="custom" prop="app_settlement_dep" label="应用结算依据" width="120">
                </el-table-column>
                <el-table-column align="center" sortable="custom" prop="channel_settlement_dep" label="渠道结算依据"
                    width="120">
                </el-table-column>
                <el-table-column align="center" sortable="custom" prop="if_send_distinct" label="发送排重" width="120">
                </el-table-column>
                <el-table-column align="center" sortable="custom" prop="if_send_click" label="发送点击" width="120">
                </el-table-column>
                <el-table-column align="center" sortable="custom" prop="if_send_activate" label="发送激活" width="120">
                </el-table-column>
                <el-table-column align="center" sortable="custom" prop="complete_time" label="完成时间" width="200">
                </el-table-column>
                <el-table-column align="center" sortable="custom" prop="add_time" label="添加时间" width="200">
                </el-table-column>
                <el-table-column align="center" label="操作" width="200">
                    <template slot-scope="scope">
                        <el-button size="mini" @click="handleEdit(scope.row)" v-auth="'putoninfo.addorupdate'">编辑
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
        <!-- 编辑界面 -->
        <el-dialog :title="title" :visible.sync="editFormVisible" width="30%" @click='closeDialog()'>
            <el-form label-width="120px" ref="editForm" :model="editForm" :rules="rules">
                <el-form-item label="明细ID" prop="puton_id" v-if="editForm.puton_id">
                    <el-input size="small" v-model="editForm.puton_id" auto-complete="off" disabled></el-input>
                </el-form-item>
                <el-form-item label="计划ID" prop="puton_plan_id">
                    <el-select size="small" v-model="editForm.puton_plan_id" placeholder="请选择" class="userRole" :disabled="isread">
                        <el-option v-for="roleItem in putonplanList" :key="roleItem.puton_plan_id"
                            :label="roleItem.puton_plan_id" :value="roleItem.puton_plan_id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="应用" prop="app_id">
                    <el-autocomplete size="small" popper-class="my-autocomplete" v-model="editForm.app_name" :disabled="isread"
                    :fetch-suggestions="paramValueSearch1" @select="handleSelect($event,3)" placeholder="渠道">
                    <i class="el-icon-edit el-input__icon" slot="suffix"></i>
                    <template slot-scope="{ item }">
                        <div class="name">{{ item.value }}</div>
                    </template>
                    </el-autocomplete>
                </el-form-item>
                <el-form-item label="渠道" prop="channel_id">
                    <el-autocomplete size="small" popper-class="my-autocomplete" v-model="editForm.channel_name" :disabled="isread"
                    :fetch-suggestions="paramValueSearch2" @select="handleSelect($event,4)" placeholder="渠道">
                    <i class="el-icon-edit el-input__icon" slot="suffix"></i>
                    <template slot-scope="{ item }">
                        <div class="name">{{ item.value }}</div>
                    </template>
                    </el-autocomplete>
                </el-form-item>
                <el-form-item label="应用单价" prop="app_price">
                    <el-input size="small" v-model="editForm.app_price" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="渠道单价" prop="channel_price">
                    <el-input size="small" v-model="editForm.channel_price" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="量级" prop="limit_num">
                    <el-input size="small" v-model="editForm.limit_num" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="关键词" prop="keywords">
                    <div class="keywords_con">
                        <div class="keywords_title">
                            <div class="keywords_title_item analysis_title_star">量级</div>
                            <div class="keywords_title_item analysis_title_star">关键词</div>
                            <div class="keywords_title_item">
                                <el-button size="mini" type="primary" @click="addDispoaeval">添加
                                </el-button>
                            </div>
                        </div>
                        <div v-for="(item,index) in editForm.keywords" :key="index" class="keywords_list">
                            <div class="keywords_list_item">
                                <el-form-item class="keywords_list_items" :prop="`keywords[${index}].limit_num`"
                                    :rules="keywordsrules.limit_num">
                                    <el-input size="small" v-model="item.limit_num" auto-complete="off"></el-input>
                                </el-form-item>
                                <el-form-item class="keywords_list_items" :prop="`keywords[${index}].keyword`"
                                    :rules="keywordsrules.keyword">
                                    <el-input size="small" v-model="item.keyword" auto-complete="off"></el-input>
                                </el-form-item>
                                <div class="keywords_list_items_btn">
                                    <el-button size="mini" type="primary" @click="delDispoae(index)">删除
                                    </el-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item label="生效日期" prop="enable_date">
                    <el-date-picker size="small" v-model="editForm.enable_date" value-format="yyyy-MM-dd" type="date" :disabled="isread"
                        placeholder="输入生效日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="生效开始时间" prop="enable_begintime">
                    <el-time-picker size="small" v-model="editForm.enable_begintime" value-format="HH:mm" format="HH:mm" type="date"
                        placeholder="输入生效开始时间">
                    </el-time-picker>
                </el-form-item>
                <el-form-item label="生效截至时间" prop="enable_endtime">
                    <el-time-picker size="small" v-model="editForm.enable_endtime" value-format="HH:mm" format="HH:mm" type="date"
                        placeholder="输入生效截至时间">
                    </el-time-picker>
                </el-form-item>
                <el-form-item label="应用结算依据" prop="app_settlement_dep">
                    <el-radio v-model="editForm.app_settlement_dep" :label="1">应用回调</el-radio>
                    <el-radio v-model="editForm.app_settlement_dep" :label="0">渠道激活</el-radio>
                </el-form-item>
                <el-form-item label="渠道结算依据" prop="channel_settlement_dep">
                    <el-radio v-model="editForm.channel_settlement_dep" :label="1">应用回调</el-radio>
                    <el-radio v-model="editForm.channel_settlement_dep" :label="0">渠道激活</el-radio>
                </el-form-item>
                <el-form-item label="发送排重" prop="if_send_distinct">
                    <el-radio v-model="editForm.if_send_distinct" :label="1">是</el-radio>
                    <el-radio v-model="editForm.if_send_distinct" :label="0">否</el-radio>
                </el-form-item>
                <el-form-item label="发送点击" prop="if_send_click">
                    <el-radio v-model="editForm.if_send_click" :label="1">是</el-radio>
                    <el-radio v-model="editForm.if_send_click" :label="0">否</el-radio>
                </el-form-item>
                <el-form-item label="发送激活" prop="if_send_activate">
                    <el-radio v-model="editForm.if_send_activate" :label="1">是</el-radio>
                    <el-radio v-model="editForm.if_send_activate" :label="0">否</el-radio>
                </el-form-item>
                <el-form-item label="是否启用" prop="if_enable">
                    <el-radio v-model="editForm.if_enable" :label="1">是</el-radio>
                    <el-radio v-model="editForm.if_enable" :label="0">否</el-radio>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click='closeDialog()'>取消</el-button>
                <el-button size="small" type="primary" class="title" @click="submitForm('editForm')">
                    保存
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    let change = [];
    import {
        putonList,
        putonplanList,
        putonInfo,
        putonSave,
        appList,
        channelList
    } from '../../api/basisMG'
    import { userList } from '../../api/userMG'
    import Pagination from '../../components/Pagination'
    export default {
        inject: ['reload'],
        data() {
            return {
                loading: false, //是显示加载
                editFormVisible: false, //控制编辑页面显示与隐藏
                title: '添加',
                isShowroleId: 'false',
                // 编辑与添加
                editForm: {
                    puton_plan_id: 0,
                    app_id: 0,
                    app_name: "",
                    channel_id: 0,
                    channel_name:"",
                    app_price: 0,
                    channel_price: 0,
                    limit_num: 0,
                    keywords: [
                        {
                            keyword: "",
                            limit_num: 0
                        }
                    ],
                    enable_date: "",
                    enable_begintime: "",
                    enable_endtime: "",
                    app_settlement_dep: 0,
                    channel_settlement_dep: 0,
                    if_send_distinct: 0,
                    if_send_click: 0,
                    if_send_activate: 0,
                    if_enable: 0
                },
                // rules 表单验证
                rules: {
                    puton_plan_id: [
                        { required: true, message: '请选择计划ID', trigger: 'blur' }
                    ],
                    app_id: [
                        { required: true, message: '请选择应用', trigger: ['blur','change'] }
                    ],
                    channel_id: [
                        { required: true, message: '请选择渠道', trigger: ['blur','change'] }
                    ],
                    app_price: [
                        { required: true, message: '请输入应用单价', trigger: 'blur' }
                    ],
                    channel_price: [
                        { required: true, message: '请输入渠道单价', trigger: 'blur' }
                    ],
                    limit_num: [
                        { required: true, message: '请输入量级', trigger: 'blur' }
                    ],
                    enable_date: [
                        { required: true, message: '请选择生效开始日期', trigger: 'blur' }
                    ],
                    enable_begintime: [
                        { required: true, message: '请选择生效开始时间', trigger: 'blur' }
                    ],
                    enable_endtime: [
                        { required: true, message: '请选择生效截至时间', trigger: 'blur' }
                    ],
                    app_settlement_dep: [
                        { required: true, message: '请选择应用结算依据', trigger: 'blur' }
                    ],
                    channel_settlement_dep: [
                        { required: true, message: '请选择渠道结算依据', trigger: 'blur' }
                    ],
                    if_send_distinct: [
                        { required: true, message: '请选择是否发送排重', trigger: 'blur' }
                    ],
                    if_send_click: [
                        { required: true, message: '请选择是否发送点击', trigger: 'blur' }
                    ],
                    if_send_activate: [
                        { required: true, message: '请选择是否发送激活', trigger: 'blur' }
                    ],
                    if_enable: [
                        { required: true, message: '请选择是否发启用', trigger: 'blur' }
                    ],
                },
                keywordsrules: {
                    limit_num: [
                        { required: true, message: '请输入量级', trigger: 'blur' }
                    ],
                    keyword: [
                        { required: true, message: '请输入关键词', trigger: 'blur' }
                    ],
                },
                formInline: {
                    pageindex: 1,
                    pagesize: 20,
                    app_id: '',
                    app_name: '',
                    channel_id: '',
                    channel_name: '',
                    enable_begindate: '',
                    enable_enddate: '',
                    orderby:''
                },
                listData: [], //投放明细数据
                // 分页参数
                pageparm: {
                    currentPage: 1,
                    pageSize: 20,
                    total: 10
                },
                appList: [],//应用列表
                channelList: [],//渠道列表
                putonplanList: [],//投放计划数据
                time: '',
                isread:false
            }
        },
        // 注册组件
        components: {
            Pagination
        },
        /**
         * 数据发生改变
         */

        watch: {},

        /**
         * 创建完毕
         */

        created() { },
        mounted() {
            /*if (this.$route.query.puton_plan_id) {
                this.formInline.puton_plan_id = this.$route.query.puton_plan_id
            }
            this.getTime();
            if (!this.formInline.enable_begindate) {
                this.formInline.enable_begindate = this.time;
            }
            var formInline = localStorage.getItem('detailed')
            if (formInline) {
                this.formInline = JSON.parse(formInline)
            }
            this.getdata(this.formInline)*/
            this.reset();
            this.getputonPlanList();
            this.getappList();
            this.getchannelList();
        },
        /**
         * 里面的方法只有被调用才会执行
         */

        methods: {
            // 获取投放明细列表
            getdata(parameter) {
                var that = this;
                that.loading = true;
                putonList(parameter)
                    .then(res => {
                        that.loading = false
                        if (res.statusCode == 200) {
                            that.listData = res.data.datas
                            // 分页赋值
                            that.pageparm.currentPage = res.data.pageindex
                            that.pageparm.pageSize = res.data.pagesize
                            that.pageparm.total = res.data.rowscount
                        } else {
                            that.$message.error(res.message)
                        }
                    })
            },
            // 获取投放计划列表
            getputonPlanList() {
                var that = this;
                var data = { 'pagesize': '0' }
                putonplanList(data)
                    .then(res => {
                        if (res.statusCode == 200) {
                            that.putonplanList = res.data.datas
                        } else {
                            that.$message.error(res.message)
                        }
                    })
            },
            // 获取明细信息
            getputonInfo(id) {
                var that = this;
                putonInfo({ puton_id: id }).then(res => {
                    if (res.statusCode == 200) {
                        that.appList.forEach(item => {
                            if(item.id == res.data.app_id){
                                res.data.app_name = item.value
                            }
                        });
                        that.channelList.forEach(item => {
                            if(item.id == res.data.channel_id){
                                res.data.channel_name = item.value
                            }
                        });
                        that.editForm = res.data;
                    } else {
                        that.$message.error(res.message)
                    }
                })
            },
            // 获取应用列表
            getappList() {
                var that = this;
                var data = { 'pagesize': '0' }
                appList(data)
                    .then(res => {
                        if (res.statusCode == 200) {
                            res.data.datas.forEach(item => {
                                that.appList.push({
                                    value: item.app_name,
                                    id: item.app_id
                                })
                            });
                        } else {
                            that.$message.error(res.message)
                        }
                    })
            },
            // 获取渠道列表
            getchannelList() {
                var that = this;
                var data = { 'pagesize': '0' }
                channelList(data)
                    .then(res => {
                        if (res.statusCode == 200) {
                            res.data.datas.forEach(item => {
                                that.channelList.push({
                                    value: item.channel_name,
                                    id: item.channel_id
                                })
                            });
                        } else {
                            that.$message.error(res.message)
                        }
                    })
            },
            // 分页插件事件
            callFather(parm) {
                this.formInline.pageindex = parm.currentPage
                this.formInline.pagesize = parm.pageSize
                localStorage.setItem('detailed', JSON.stringify(this.formInline))
                this.getdata(this.formInline)
            },
            // 排序
            sortChange(column, prop, order) {
                var order = '';
                if (column.order == 'ascending') {
                    order = 'asc'
                } else if (column.order == 'descending') {
                    order = 'desc'
                }
                if (order) {
                    this.formInline.orderby = column.prop + ' ' + order
                    this.search();
                }
            },
            // 搜索事件
            search() {
                this.formInline.pageindex = 1;
                localStorage.setItem('detailed', JSON.stringify(this.formInline))
                this.getdata(this.formInline)
            },
            // 重置
            reset() {
                this.formInline = {
                    pageindex: 1,
                    pagesize: 20,
                    puton_plan_id: '',
                    app_id: '',
                    app_name: '',
                    channel_id: '',
                    channel_name: '',
                    enable_begindate: '',
                    enable_enddate: '',
                    orderby:''
                }

                if (this.$route.query.puton_plan_id) {
                    this.formInline.puton_plan_id = this.$route.query.puton_plan_id
                }
                this.getTime();
                this.formInline.enable_begindate = this.time;
                // this.formInline.enable_enddate = this.time;

                // 重置清掉本地搜索缓存
                localStorage.removeItem('detailed')
                this.getdata(this.formInline)
            },
            //显示编辑界面
            handleEdit: function (row) {
                this.editFormVisible = true
                if (row != undefined && row != 'undefined') {
                    this.title = '修改'
                    this.isread = true
                    this.getputonInfo(row.puton_id);
                } else {
                    this.title = '添加'
                    this.isread = false
                    this.editForm = {
                        puton_plan_id: 0,
                        app_id: 0,
                        app_name: "",
                        channel_id: 0,
                        channel_name:"",
                        app_price: 0,
                        channel_price: 0,
                        limit_num: 0,
                        keywords: [
                            {
                                keyword: "",
                                limit_num: 0
                            }
                        ],
                        enable_date: this.time,
                        enable_begintime: "",
                        enable_endtime: "",
                        app_settlement_dep: 0,
                        channel_settlement_dep: 0,
                        if_send_distinct: 0,
                        if_send_click: 0,
                        if_send_activate: 0,
                        if_enable: 0
                    }
                }
            },
            // 编辑、增加页面保存方法
            submitForm(editData) {
                var that = this;
                this.$refs[editData].validate(valid => {
                    if (valid) {
                        var editForm = that.editForm
                        // 添加没有puton_id
                        if (!editForm.puton_id) {
                            delete editForm.puton_id
                        }
                        delete editForm.app_name
                        delete editForm.channel_name
                        putonSave(editForm)
                            .then(res => {
                                that.editFormVisible = false
                                if (res.statusCode == 200) {
                                    // 添加时清空搜索条件
                                    if (that.title == '添加') {
                                        that.reset();
                                    } else {
                                        that.getdata(that.formInline)
                                    }
                                    that.$message({
                                        type: 'success',
                                        message: that.title + '成功！'
                                    })
                                } else {
                                    that.$message.error(res.message)
                                }
                            })
                    } else {
                        return false
                    }
                })
            },
            // 关闭编辑、增加弹出框
            closeDialog() {
                this.editFormVisible = false
                this.isread = false
            },
            // 添加配置
            addDispoaeval() {
                this.editForm.keywords.push({
                    keyword: "",
                    limit_num: 0
                })
            },
            // 删除配置
            delDispoae(index){
                this.editForm.keywords.splice(index,1)
            },
            // 获取当前日期
            getTime() {
                const date = new Date();
                const Y = date.getFullYear();
                const M = date.getMonth() < 9 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
                const D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
                this.time = Y + '-' + M + '-' + D;
            },
            // 自定义输入下拉框
            paramValueSearch1(queryString, cb) {
                var appList = this.appList;
                var results = queryString ? appList.filter(this.createFilter(queryString)) : appList;
                // 调用 callback 返回建议列表的数据
                cb(results);
            },
            paramValueSearch2(queryString, cb) {
                var channelList = this.channelList;
                var results = queryString ? channelList.filter(this.createFilter(queryString)) : channelList;
                // 调用 callback 返回建议列表的数据
                cb(results);
            },
            createFilter(queryString) {
                return (restaurant) => {
                    return restaurant.value.toUpperCase().match(queryString.toUpperCase()) //模糊查询
                    // return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0); // 精准查询
                };
            },
            handleSelect(item,index){
                if(index == 1){
                    this.formInline.app_id = item.id;
                    this.formInline.app_name = item.value;
                }else if(index == 2){
                    this.formInline.channel_id = item.id;
                    this.formInline.channel_name = item.value;
                }else if(index == 3){
                    this.editForm.app_id = item.id;
                    this.editForm.app_name = item.value;
                }else if(index == 4){
                    this.editForm.channel_id = item.id;
                    this.editForm.channel_name = item.value;
                }
            },
            handleChange1(val){
                if(val == ''){
                    this.formInline.app_id = '';
                    this.formInline.app_name = '';
                    localStorage.setItem('detailed', JSON.stringify(this.formInline))
                }
            },
            handleChange2(val){
                if(val == ''){
                    this.formInline.channel_id = '';
                    this.formInline.channel_name = '';
                    localStorage.setItem('detailed', JSON.stringify(this.formInline))
                }
            },
        }
    }
</script>

<style scoped>
    .user-search {
        margin-top: 20px;
    }

    .userRole {
        width: 100%;
    }

    .keywords_con {
        display: flex;
        flex-direction: column;
        border-top: 1px solid #EBEEF5;
        border-left: 1px solid #EBEEF5;
        box-sizing: border-box;
    }

    .keywords_con .keywords_title {
        display: flex;
    }

    .keywords_con .keywords_title .keywords_title_item {
        width: 30%;
        padding: 8px 10px;
        text-align: center;
        border-right: 1px solid #EBEEF5;
        border-bottom: 1px solid #EBEEF5;
        box-sizing: border-box;
    }

    .keywords_con .keywords_list {
        display: flex;
        flex-direction: column;
    }

    .keywords_con .keywords_list .keywords_list_item {
        display: flex;
    }

    .keywords_con .keywords_list .keywords_list_item .keywords_list_items {
        width: 30%;
        padding: 8px 10px;
        text-align: center;
        border-bottom: 1px solid #EBEEF5;
        border-right: 1px solid #EBEEF5;
        box-sizing: border-box;
    }

    .keywords_con .keywords_list .keywords_list_item .keywords_list_items_btn {
        width: 30%;
        padding: 12px;
        border-bottom: 1px solid #EBEEF5;
        border-right: 1px solid #EBEEF5;
        box-sizing: border-box;
        display: flex;
        justify-content: center;
    }
    .analysis_title_star:before {
        content: '*';
        color: red;
        padding-right: 3px;
    }
</style>
<style>
    .detailed .el-table-con {
        height: calc(100vh - 380px) !important;
    }

    .detailed .page-box {
        text-align: right !important;
    }

    .detailed .el-table__body-wrapper {
        overflow-y: auto !important;
        max-height: calc(100vh - 460px) !important;
    }

    .detailed .el-dialog__body {
        max-height: 55vh;
        overflow-y: scroll;
    }

    .detailed .el-dialog__body::-webkit-scrollbar {
        display: none;
    }

    /*  */
    /* .detailed .el-table{
        overflow: auto;
    }
    .detailed .el-table__header-wrapper,
    .detailed .el-table__body-wrapper,
    .detailed .el-table__footer-wrapper{overflow:visible;}
    .detailed el-table::after{
      position: relative;
    }
    .detailed .el-table--border:after,.detailed .el-table--group:after, .detailed .el-table:before {
        display:none
    }

    .detailed .el-table--scrollable-x .el-table__body-wrapper {
        overflow-x: hidden;
        width: fit-content;
    } */
    /*  */
</style>


// WEBPACK FOOTER //
// src/views/release/detailed.vue